import * as c from 'common/c'

export const notificationsFetched = (data) => {
  return {
    type: c.NOTIFICATIONS_FETCHED,
    payload: data,
  }
}

export const notificationsRead = (data) => {
  return {
    type: c.NOTIFICATIONS_READ,
    payload: data,
  }
}

export const notificationsDismissed = (data) => {
  return {
    type: c.NOTIFICATIONS_DISMISSED,
    payload: data,
  }
}

export const unreadNotificationsCountFetched = (data) => {
  return {
    type: c.UNREAD_NOTIFICATIONS_COUNT_FETCHED,
    payload: data,
  }
}

export const notificationsReadIds = (data) => {
  return {
    type: c.NOTIFICATIONS_READ_IDS,
    payload: data,
  }
}
